export const externalLinks = {
  header: {
    bonusSystemDetailsLink: '/storage/pdf/rules.pdf',
  },
};
